import jQuery from "jquery";
import View from "../framework/view";
import Server from "../server";
import {Recording} from "../bo/recording";
import template from "../../pugc/review";

// Global list for disposal - this implementation implies that we can only have one player at a time.
const players : any[] = [];

let videoid = 0;

export default class ReviewView extends View {

    public static classname = "review-view";

    private server = Server.instance();

    private token: string;

    private recording: Recording | undefined;

    private player : any;

    private redraw : any = undefined;

    constructor(token: string) {
        super(ReviewView.classname);
        this.token = token;
        this.refresh();
    }

    refresh() {
        this.server.fetchRecordingByToken(this.token).then((recording) => {
            this.recording = recording;
            this.setRecordingOnPlayer();
            this.update();
            this.config();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            left_right_controls: this.recording && this.recording.left_right,
            recording: this.recording,
        }

        const out = this.pug(template, data);

        this.afterUpdate(() => {

            const v = this.elt().find("video-js");

            if (v.length == 1 && ! v.data("initted")) {

                const id = this.getUuid() + "-video-" + (++videoid);
                v.attr("id", id);
                v.data("initted", true);

                const configOptions = (newOpts: any) => {
                    this.elt().find(".loop-a").text(newOpts.start ? "A " + Math.round(newOpts.start * 10) / 10 : "A");
                    this.elt().find(".loop-b").text(newOpts.end ? "B " + Math.round(newOpts.end * 10) / 10 : "B");
                }

                // @ts-ignore
                this.player = videojs(v[0], {
                    preload: true,
                    fluid: true,
                    controls: true,
                    playbackRates: [0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
                    plugins: {
                        abLoopPlugin: {
                            createButtons: true,
                            onOptionsChange: function (optionDetails: any, api: any, player: any) {
                                console.log("options changed: ", player.id(), optionDetails);
                                configOptions(optionDetails.newOpts);
                            }
                        }
                    }
                });

                this.player.crossOrigin = "anonymous";

                const videoElt = this.elt().find("video");
                const vid = videoElt[0] as HTMLVideoElement;
                vid.crossOrigin = "anonymous";

                for (const p of players) {
                    p.dispose();
                }
                players.length = 0;

                players.push(this.player);

                if (this.recording) {
                    this.setRecordingOnPlayer();
                }

                this.player.on(["play", "seeked", "pause", "ready", "durationchange"], () => {
                    this.config();
                });

            }
        });

        return out;
    }

    drawCanvas() {

        const canvas = this.elt().find("canvas");
        if (canvas.length == 0) {
            return;
        }

        const ctx = canvas[0].getContext("2d");
        if (! ctx) {
            return;
        }

        const width = canvas[0].width;
        const height = canvas[0].height;

        ctx.fillStyle = "rgb(255 255 255)";
        ctx.fillRect(0, 0, width, height);

        if (! this.player) {
            return;
        }

        const pos = this.player.currentTime();
        const duration = this.player.duration();

        ctx.fillStyle = "rgb(255 0 0)";

        const x = pos / duration * width;

        ctx.fillStyle = "rgb(0 0 0)";
        ctx.fillRect(x, 0, 1, height);

        if (! this.player.paused()) {
            if (this.redraw) {
                window.cancelAnimationFrame(this.redraw);
            }
            this.redraw = window.requestAnimationFrame(() => {
                this.drawCanvas();
            });
        }
    }

    setRecordingOnPlayer() {
        if (this.recording && this.player) {

            console.log("Set recording", this.recording);

            this.player.src({
                src: this.recording.url,
                type: "video/mp4"
            });
            this.config();
        }
    }

    config() {
        const playing = this.player && ! this.player.paused();
        const e = this.elt();
        this.drawCanvas();
    }

    seekX(x: number) {
        const canvas = this.elt().find(".marks canvas")[0];
        if ( !this.player || ! canvas) {
            return;
        }
        const rect = canvas.getBoundingClientRect();
        const duration = this.player.duration();
        const pos = (x - rect.left) / rect.width * duration;
        this.player.currentTime(pos);
    }

    rewind() {
        const pos = 0;
        this.player && this.player.currentTime(pos);
    }
    play() {
        this.player && this.player.play();
        this.config();
    }
    pause() {
        this.player && this.player.pause();
        this.config();
    }

    async setActivation(active: boolean) {
        if (! this.recording) {
            return;
        }
        const done = await this.server.setActivationByToken(this.token, active);
        this.recording.active = active;
        this.update(".controls");
    }
}

View.on(
    "." + ReviewView.classname,
    "click",
    "button.rewind",
    function(that: ReviewView, event, elt) {
        event.preventDefault();
        that.rewind();
    });

View.on(
    "." + ReviewView.classname,
    "click",
    "button.play",
    function(that: ReviewView, event, elt) {
        event.preventDefault();
        that.play();
    });
View.on(
    "." + ReviewView.classname,
    "click",
    "button.pause",
    function(that: ReviewView, event, elt) {
        event.preventDefault();
        that.pause();
    });

View.on(
    "." + ReviewView.classname,
    "click",
    "button.activation",
    function(that: ReviewView, event, elt) {
        event.preventDefault();
        const active = jQuery(elt).data("active") ? true : false;
        that.setActivation(active);
    });

